export enum EntityName {
  EventInformation = 'uds_eventinformation',
  Incident = 'incident',
  IncidentBoard = 'incident_board',
  Task = 'task',
}
